module.exports = __webpack_public_path__ + "img/frame (44).06e986f8.jpg";